import React from "react";
import "./App.css";
import AppRouter from "./router";

function App() {
  return (
    <div className="App">
      <div className="window">
        <AppRouter />
      </div>
    </div>
  );
}

export default App;
